import { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDataApi } from '@adsk/alloy-helpers';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { buildGetAccountOfferingsRequest } from './utils';

export const extractProducts = (offerings) => {
  if (!offerings) {
    return [];
  }

  return _.chain(offerings)
    .map((offering) =>
      offering.products.map((product) => ({
        ...product,
        included:
          offering.type.toUpperCase() === 'NONE' ? false : product.included,
      }))
    )
    .flatten()
    .orderBy('included', 'desc')
    .unionBy('type')
    .value();
};

const useGetAccountOfferings = (enable = true) => {
  const accountId = useCurrentAccountId();
  const {
    data: offeringsData,
    error: offeringsError,
    loading: offeringsDataLoading,
    doFetch: doGetAccountOfferings,
  } = useDataApi();

  useEffect(() => {
    if (!accountId || !enable) return;

    doGetAccountOfferings(buildGetAccountOfferingsRequest(accountId));
  }, [accountId, enable, doGetAccountOfferings]);

  const [offeringProducts, setProducts] = useState();
  const [isLoadingOfferingProducts, setIsLoadingOfferingProducts] =
    useState(false);

  useEffect(() => {
    setIsLoadingOfferingProducts(offeringsDataLoading);
    if (offeringsData && offeringsData.results && !offeringsError && enable) {
      setProducts(extractProducts(offeringsData.results));
    }
  }, [enable, offeringsData, offeringsDataLoading, offeringsError]);

  return { offeringProducts, isLoadingOfferingProducts };
};

export default useGetAccountOfferings;
